// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__YlVX9","divider-text":"Divider_divider-text__uuYJK"};